<template>
  <div>
    <div class="form-group mb-0">
        <label for="doc">{{name}}</label>
    </div>
    <div class="custom-file mb-5">
        <input type="file" class="file-input" @change="checkFile()"  :ref = reference >
        <label class="file-label" for="DocFile">{{textLabel}}</label>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ContainerUploadDoc',
  props: [ 'name','reference','id','eventType'],
  data(){
    return {
        textLabel: 'Selecionar archivo',
        file: '',
     }
  },
  mounted () {
  },
  methods: {
    checkFile: function () {
      this.file = this.$refs[this.reference].files[0]
      this.$store.commit('container/set_documents',  [this.file, this.name, this.id, this.eventType ])
      this.textLabel=this.file.name
    }
  }
}
</script>

<style lang= "scss" scoped>


</style>
